import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { ArrowLeft, History } from 'lucide-react'
import BuyCoinsPaymentModal from '../../Components/Wallet/modals/BuyCoinsPaymentModal'
import BDCoinIcon from '../../Assets/icons/coin.png'
import BuyCoinsGrid from '../../Components/Wallet/BuyCoinsGrid'
import TransactionSection from '../../Components/Wallet/TransactionSection'
// import ProUpgradeButton from '../../Components/RevenueCat/ProUpgradeButton'
import { useCoinPackages, useWalletDetails } from '../../hooks/api/useWallet'
import { useNavigate } from 'react-router-dom'
import TransactionDetailsModal from '../../Components/Wallet/TransactionDetailsModal'
import { formatNumber } from '../../helper'

export default function WalletCoin() {
    const navigate = useNavigate()
    const [view, setView] = useState('main')
    const [selectedOffer, setSelectedOffer] = useState(null)
    const { data: coinPackages, isLoading, isError, refetch } = useCoinPackages()
    const { data: walletDetails } = useWalletDetails();
    const [transactionDetails, setTransactionDetails] = useState(null)
    const bdCoinBalance = walletDetails?.coinBalance || 0

    const offers = (coinPackages || []).map((pkg) => ({
        coinPackageId: pkg.coinPackageId,
        revenueCatProductId: pkg.revenueCatProductId,
        name: pkg.name,
        coins: pkg.amount,
        price: `$${Number(pkg.price).toFixed(2)}`,
        description: pkg.description,
    }))

    const handleSelectOffer = (offer) => setSelectedOffer(offer)
    const handleCloseModal = () => setSelectedOffer(null)

    // ================= HISTORY VIEW =================
    if (view === 'history') {
        return (
            <div className="min-h-screen bg-[#1a1a1a] text-white p-4 md:p-6">

                {/* Header with Back */}
                <div className="flex items-center gap-3 mb-6">
                    <button
                        onClick={() => {
                            if (transactionDetails) setTransactionDetails(null)
                            setView('main')
                        }}
                        className="hover:text-gray-300 transition"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <h2 className="text-lg font-semibold">Transaction History</h2>
                </div>

                {transactionDetails &&
                    <TransactionDetailsModal
                        transaction={transactionDetails}
                        onClose={() => setTransactionDetails(null)}
                    />
                }

                {/* Transactions */}
                <TransactionSection onTransactionClick={setTransactionDetails} />
            </div>
        )
    }

    // ================= MAIN VIEW =================
    return (
        <div className="min-h-screen bg-customDark text-white p-2 md:p-4 overflow-x-hidden">

            {/* Header */}
            <div className="flex items-center bg-customGray justify-between mb-6 rounded-xl p-6 md:p-8">
                <div className='flex items-center gap-3'>
                    <button
                        onClick={() => navigate(-1)}
                        className="hover:text-gray-300 transition"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <h1 className="text-xl md:text-2xl font-bold">Buy BD Coins</h1>
                </div>

                <div className="flex items-center gap-4">
                    {/* <ProUpgradeButton /> */}

                    <button
                        onClick={() => setView('history')}
                        className="flex items-center gap-2 hover:text-gray-300 transition text-sm"
                    >
                        <History className="w-4 h-4" />
                        <span className="hidden sm:inline">Transaction History</span>
                        <span className="sm:hidden">History</span>
                    </button>
                </div>
            </div>

            {/* Coin Packages */}
            <div className="bg-customGray rounded-xl p-4 overflow-x-auto">
                <div className="flex items-center justify-between mb-4 min-w-max md:min-w-0">
                    <h2 className="text-base font-semibold">Coin Packages</h2>

                    <div className="flex items-center gap-1 text-sm">
                        <span>BD Coin balance:</span>
                        <img
                            src={BDCoinIcon}
                            alt="bd-coin-icon"
                            className="w-[14px] h-[14px]"
                        />
                        <span>{formatNumber(bdCoinBalance)}</span>
                    </div>
                </div>

                {isLoading && (
                    <p className="text-gray-400 text-sm text-center py-6">Loading coin packages...</p>
                )}

                {isError && (
                    <div className="text-center py-6">
                        <p className="text-red-400 text-sm mb-2">Unable to load coin packages.</p>
                        <button onClick={() => refetch()} className="text-[#c9a227] text-sm hover:underline">
                            Try again
                        </button>
                    </div>
                )}

                {!isLoading && !isError && (
                    <BuyCoinsGrid
                        offers={offers}
                        onSelect={handleSelectOffer}
                    />
                )}
            </div>

            {/* Modal */}
            <AnimatePresence>
                {selectedOffer && (
                    <BuyCoinsPaymentModal
                        offer={selectedOffer}
                        onClose={handleCloseModal}
                    />
                )}
            </AnimatePresence>
        </div>
    )
}
